export function hasDeliveryAddressFields(a) {
    if (!a)
        return false;
    return Boolean(a.city.trim() && a.street.trim() && a.house.trim());
}
/** @deprecated use hasDeliveryAddressFields */
export function isDeliveryAddressValidForRestaurants(a) {
    return hasDeliveryAddressFields(a);
}
export function cartProductIds(cartItems) {
    const ids = cartItems
        .filter((it) => it.kind === 'product')
        .map((it) => it.product.id);
    return [...new Set(ids)];
}
/** Показывать выбор адреса ресторана при доставке (не зависит от адреса пользователя). */
export function shouldShowDeliveryRestaurantPicker(deliveryType, restaurantsCount) {
    return deliveryType === 'delivery' && restaurantsCount > 1;
}
export function filterSuitableRestaurantsForCart(restaurants, cartItems) {
    const productItems = cartItems.filter((it) => it.kind === 'product');
    if (productItems.length === 0)
        return restaurants;
    return restaurants.filter((r) => productItems.every((it) => !(it.product.disabledRestaurantIds ?? []).includes(r.id)));
}
